import { ElLoading } from 'element-plus'

/**
 * 通用步骤加载蒙层封装
 * 在指定容器上展示 Element Plus Loading，执行异步任务，任务完成后自动关闭
 *
 * @param {Function} task - 异步任务函数，需返回 Promise
 * @param {Object} options - 配置项
 * @param {string} [options.target='.upload-form-wrapper'] - Loading 作用的 DOM 选择器
 * @param {string} [options.text='处理中...'] - Loading 文案
 * @param {string} [options.background='rgba(255, 255, 255, 0.6)'] - 背景遮罩颜色
 * @returns {Promise<void>}
 */
export async function withLoading(task, options = {}) {
  const {
    target = '.upload-form-wrapper',
    text = '处理中...',
    background = 'rgba(255, 255, 255, 0.6)'
  } = options

  const loadingInstance = ElLoading.service({
    target,
    lock: true,
    text,
    background
  })

  try {
    await task()
  } finally {
    loadingInstance.close()
  }
}

